// extracted by mini-css-extract-plugin
export var checkbox = "_6u-0";
export var circle = "_6u-3";
export var horizontalContainer = "_6u-7";
export var sm = "_6u-5";
export var switch0 = "_6u-2";
export var switchDisabled = "_6u-8";
export var switchEnabled = "_6u-1";
export var textSwitchContainer = "_6u-9";
export var textSwitchOption = "_6u-a";
export var textSwitchOptionSelected = "_6u-b";
export var verticalContainer = "_6u-6";
export var xs = "_6u-4";